/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyContact } from './EmergencyContact';
import {
    EmergencyContactFromJSON,
    EmergencyContactFromJSONTyped,
    EmergencyContactToJSON,
    EmergencyContactToJSONTyped,
} from './EmergencyContact';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListEmergencyContactsResponse
 */
export interface ListEmergencyContactsResponse {
    /**
     * 
     * @type {Array<EmergencyContact>}
     * @memberof ListEmergencyContactsResponse
     */
    data: Array<EmergencyContact>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmergencyContactsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmergencyContactsResponse interface.
 */
export function instanceOfListEmergencyContactsResponse(value: object): value is ListEmergencyContactsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmergencyContactsResponseFromJSON(json: any): ListEmergencyContactsResponse {
    return ListEmergencyContactsResponseFromJSONTyped(json, false);
}

export function ListEmergencyContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmergencyContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmergencyContactFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmergencyContactsResponseToJSON(json: any): ListEmergencyContactsResponse {
      return ListEmergencyContactsResponseToJSONTyped(json, false);
  }

  export function ListEmergencyContactsResponseToJSONTyped(value?: ListEmergencyContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmergencyContactToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

